import { SelectOption } from "../inputFactory.interface";

export type DecisionType = 'S' | 'N';

export enum DECISION_TYPE {
  YES = 'S',
  NO = 'N',
}

export enum DECISION_TYPE_BOOLEAN {
  YES = 'true',
  NO = 'false',
}

export const OPTION_YES_OR_NOT: SelectOption[] = [
  {
    label: 'SI',
    value: DECISION_TYPE.YES,
  },
  {
    label: 'NO',
    value: DECISION_TYPE.NO,
  },
];

export const OPTION_YES_OR_NOT_BOOLEAN: SelectOption[] = [
  {
    label: 'SI',
    value: DECISION_TYPE_BOOLEAN.YES,
  },
  {
    label: 'NO',
    value: DECISION_TYPE_BOOLEAN.NO,
  },
];

export const OPTIONS_BILLING_PERIOD = [
    {label: 'Anual', value: 'A'},
    {label: 'Mensual', value: 'M'},
];

export const OPTION_VALIDITY_PERIOD = [
    {label: 'Anual', value: 'A'}
];

export const OPTION_INJURY_TYPES: SelectOption[] = [
  { label: 'Leves (L)', value: 'L' },
  { label: 'Graves (G)', value: 'G' },
  { label: 'Muerte (M)', value: 'M' },
];


export const MOCK_ROUTES_TYPES = [
  {
    value: 'N',
    label: 'NACIONAL',
  },
  {
    value: 'P',
    label: 'PROVINCIAL',
  },
];

export const MOCK_TRAFFIC_LIGHTS = {
    "trafficLights": [
        {
          "label": "ROJO",
          "value": "ROJO"
        },
        {
          "label": "VERDE",
          "value": "VERDE"
        },
        {
          "label": "AMARILLO",
          "value": "AMARILLO"
        },
        {
          "label": "INTERMITENTE",
          "value": "INTERMITENTE"
        }
      ]
}

